( function () {
	'use strict';

	function logger ( $log, ngToastr, apiResponses ) {
		function error ( message, data ) {
			$log.error( 'Error: ' + message, data );
		}

		function info ( message, data ) {
			$log.info( 'Info: ' + message, data );
		}

		function success ( message, data ) {
			$log.info( 'Success: ' + message, data );
		}

		function warning ( message, data ) {
			$log.warn( 'Warning: ' + message, data );
		}

		function notifyError ( message, title ) {
			ngToastr.error( message, title );
		}

		function notifyInfo ( message, title ) {
			ngToastr.info( message, title );
		}

		function notifySuccess ( message, title ) {
			ngToastr.success( message, title );
		}

		function notifyWarning ( message, title ) {
			ngToastr.warning( message, title );
		}

		function notifyErrorCode ( code, messageObj ) {
			var responses = apiResponses( code, messageObj );

			ngToastr.error( responses.message, responses.title );
		}

		function notifyErrorPath ( url ) {
			notifyError( 'Sorry, the page "' + url + '" is currently unavailable or does not exist.', '' );
		}

		function configureToastr () {
			ngToastr.options = {
				'closeButton'       : false,
				'debug'             : false,
				'newestOnTop'       : false,
				'progressBar'       : false,
				'positionClass'     : 'toast-top-right',
				'preventDuplicates' : true,
				'onclick'           : null,
				'showDuration'      : '1000',
				'hideDuration'      : '1500',
				'timeOut'           : '5000',
				'extendedTimeOut'   : '1000',
				'showEasing'        : 'swing',
				'hideEasing'        : 'linear',
				'showMethod'        : 'fadeIn',
				'hideMethod'        : 'fadeOut'
			};
		}

		configureToastr();

		var service = {
			'error'           : error,
			'info'            : info,
			'success'         : success,
			'warning'         : warning,
			'notifyError'     : notifyError,
			'notifyInfo'      : notifyInfo,
			'notifySuccess'   : notifySuccess,
			'notifyWarning'   : notifyWarning,
			'notifyErrorCode' : notifyErrorCode,
			'notifyErrorPath' : notifyErrorPath,
			'log'             : $log.log
		};

		return service;
	}

	angular
		.module( 'blocks.logger' )
		.value( 'ngToastr', window.toastr )
		.factory( 'logger', logger );

	logger.$inject = [ '$log', 'ngToastr', 'apiResponses' ];
} )( );
